export default __webpack_public_path__ + "static/CustomerPic4-7d18aad60e589e9e148c1b0d8d9bee61.png";